import Tracking from "./tracking";

export default class TrackLists {

	private listContainer: HTMLDivElement;
	private listId: string;
	private listName: string;

	constructor(listContainer) {
		if (listContainer.getAttribute('data-has-tracked-list-view')
			&& listContainer.getAttribute('data-has-tracked-list-view') === "true") {
			return;
		}
		this.listContainer = listContainer;
		this.listId = this.listContainer.getAttribute('data-list-id');
		this.listName = this.listContainer.getAttribute('data-list-name');

		if (this.getItems().length) {
			Tracking.trackListView(this.listId, this.listName, this.getItems());
			this.trackSelectItems();
			listContainer.setAttribute('data-has-tracked-list-view', 'true');
		}
		
	}

	private getItems() {

		let items = [];
		const products = this.listContainer.querySelectorAll('[data-product-id]');
		for (let i = 0; i < products.length; i++) {
			const currentProduct = products[i];
			items.push(Tracking.getItemDetails(currentProduct as HTMLDivElement));
		}
		return items;

	}

	private trackSelectItems() {
		const productLinks = this.listContainer.querySelectorAll('.js-product-link');
		for (let i = 0; i < productLinks.length; i++) {
			const currentProductLink = productLinks[i];
			currentProductLink.addEventListener('click', () => {
				this.trackSelectItem(currentProductLink as HTMLLinkElement);
			});
		}
	}

	private trackSelectItem(element: HTMLLinkElement) {
		const elementParent = element.closest('[data-product-id]') as HTMLDivElement;
		const item = Tracking.getItemDetails(elementParent);
		Tracking.trackSelectItem(this.listId, this.listName, item);
	}

}
